import {api} from '../../api';
import {createMutation} from '../../lib';

const {postContractsArchive} = api.contracts;

export const usePostContractsArchiveMutation = createMutation((params: Parameters<typeof postContractsArchive>) =>
  postContractsArchive(...params),
);
